import CurrencyFormatter from './CurrencyFormatter';
import { app } from '../tnew';


/** @type {CurrencyFormatter} */
let currencyFormatter;


async function getCurrencyFormatter() {
  if (currencyFormatter) {
    return currencyFormatter;
  }

  let Class = CurrencyFormatter;

  if (!window.Intl) {
    const module = await import('./FallbackCurrencyFormatter' /* webpackChunkName: "tnew-fallback-currency-formatter" */);

    Class = module.default;
  }

  currencyFormatter = new Class(app.bcp47LanguageTag, app.iso4217CurrencyCode);

  return currencyFormatter;
}


export default getCurrencyFormatter;




// WEBPACK FOOTER //
// ./V7/tnew/currency/getCurrencyFormatter.js